<template>
  <!-- 购物打卡-参与记录 -->
  <div>
    <jd-form
      class="mb16"
      :form-info="inputData"
      @search="search"
      :emitReset="true"
      @reset="search({}, 'reset')"
      ref="inputFormRef">
      <template #finishCycleNumStart>
        <div style="display: flex">
          <el-input
            v-model="formList.finishCycleNumStart"
            placeholder="请输入次数"
            style="width: 133px"
            @input="
              formList.finishCycleNumStart = getNumberData(
                1,
                $event,
                0,
                0,
                999999
              )
            "></el-input>
          <div class="time_to_text">至</div>
          <el-input
            v-model="formList.finishCycleNumEnd"
            placeholder="请输入次数"
            style="width: 133px"
            @input="
              formList.finishCycleNumEnd = getNumberData(
                1,
                $event,
                0,
                0,
                999999
              )
            "></el-input>
        </div>
      </template>
    </jd-form>

    <div style="margin-bottom: 12px" class="flex-between">
      <jd-button @click="addCrowd" :disabled="tableData.length <= 0"
        >按查询结果生成人群</jd-button
      >
      <jd-button type="text" @click="exportAll">导出</jd-button>
    </div>

    <div class="new-table-box">
      <jd-table
        :loading="loading"
        :tableData="tableData"
        :pageInfo="{
          pageSize: formList.size,
          pageNum: formList.current,
          total: total,
        }"
        @handlePage="handlePage">
        <el-table-column prop="memberNick" label="用户昵称" min-width="120">
        </el-table-column>
        <el-table-column
          :prop="chaosParams"
          :label="`用户${grayText}`"
          min-width="150"></el-table-column>
        <el-table-column prop="sellerLinkName" label="投放渠道" min-width="120">
        </el-table-column>
        <el-table-column prop="createTime" label="参与时间" min-width="180">
        </el-table-column>
        <el-table-column
          prop="finishCycleNum"
          label="周期打卡达标数"
          width="180">
          <template slot-scope="scope">
            <span style="margin-right: 5px"
              >{{ scope.row.finishCycleNum }}次</span
            >
            <jd-button type="blueText" @click="handleOpenDetail(scope.row)">
              查看明细
            </jd-button>
          </template>
        </el-table-column>
      </jd-table>
    </div>

    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="formList"
      :activityType="53"
      :source="40"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose" />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"></generate>
  </div>
</template>

<script>
import { getOrderApply, exportOrderApply } from "@/api/jhk/shoppingCheckIn.js";
import crowdDialog from "../crowd-Dialog.vue";
import statisticsData from "@/mixin/activity_statistics_new.js";
import { customSellerLinkPage } from "@/api/jhk/activityController";
export default {
  mixins: [statisticsData],
  components: {
    crowdDialog,
  },
  props: {
    activityId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      inputData: [
        {
          label: "用户昵称：",
          type: "Input",
          prop: "memberNick",
          placeholder: "请输入",
        },
        {
          label: "用户PIN：",
          type: "Input",
          prop: "pin",
          placeholder: "请输入",
        },
        {
          label: "参与时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "createTimeStart",
          endKey: "createTimeEnd",
          startPlaceholder: "选择日期时间",
          endPlaceholder: "选择日期时间",
          defalutLimit: true,
        },
        // {
        //   label: "参与时间：",
        //   myDate: true,
        //   prop: ["createTimeStart", "createTimeEnd"],
        //   startPlaceholder: "选择日期时间",
        //   endPlaceholder: "选择日期时间",
        // },
        {
          label: "周期打卡达标数：",
          slot: "finishCycleNumStart",
          prop: "finishCycleNumStart",
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
          ],
        },
      ],
      tableData: [],
      formList: {
        current: 1,
        size: 10,
        activityId: this.activityId,
        finishCycleNumStart: "",
        finishCycleNumEnd: "",
      },
      total: 0,
      loading: false,
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: false, // 是否有默认值
      defaultValueText: "", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      sellerLinkList:[]
    };
  },
  computed: {
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'pin'
    },
  },
  watch: {
    searchGrayId: {
    handler(newVal, oldVal) {
      this.inputData.forEach((item)=>{
        if(item.prop=='pin') {
          item.label = item.label.replace(/pin/ig, newVal)
          item.prop = newVal;
          item.placeholder = item.placeholder.replace(/pin/ig, newVal)
        }
      })
    },
    immediate: true,
  },
  },
  mounted() {
    this.searchMethods();
    this.getCustomSellerLinkPage();
  },
  methods: {
    //投放渠道
    getCustomSellerLinkPage() {
      customSellerLinkPage({
        current: 1,
        size: 10000,
        activityId: this.activityId,
      }).then((res)=>{
        if(res.code==1) {
           this.sellerLinkList = res.data.records || [];
           this.sellerLinkList.unshift({
            id: "",
             sellerLinkName: "全部"
           },
           {
             id: "0",
             sellerLinkName: "默认渠道"
            },
          )
          const list = this.sellerLinkList.map((item)=>{
            return {
              label: item.sellerLinkName,
              value: item.id
            }
          })
          this.inputData.some((item)=>{
            if(item.prop=='sellerLinkId') {
              item.options = list
            }
          })
        }
      })
    },
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = "购物打卡-参与记录-";
      this.isShowCrowdDialog = true;
    },
    handleOpenDetail(row) {
      this.$emit("handleOpenDetail", row);
    },
    exportAll() {
      this.openRemarkDialog = true;
    },

    confirmExport(exportRemark = "") {
      let obj = this.$refs.inputFormRef.getSearchForm();
      let params = {
        ...obj,
        finishCycleNumEnd:this.formList.finishCycleNumEnd,
        finishCycleNumStart:this.formList.finishCycleNumStart,
        activityId: this.activityId,
        current: 1,
        size: 9999999,
        remark: exportRemark,
      };
      exportOrderApply(params).then((res) => {});
    },
    handlePage({ pageSize, pageNum }) {
      this.formList.size = pageSize;
      this.formList.current = pageNum;
      this.searchMethods();
    },
    search(params, type) {
      this.formList = {
        ...params,
        activityId: this.activityId,
        finishCycleNumStart: this.formList.finishCycleNumStart,
        finishCycleNumEnd: this.formList.finishCycleNumEnd,
      };
      this.formList.current = 1;
      this.formList.size = 10;
      if (type == "reset") {
        this.formList = {
          size: 10,
          current: 1,
          activityId: this.activityId,
          finishCycleNumStart: "",
          finishCycleNumEnd: "",
        };
        this.$nextTick(() => {
          this.$refs.inputFormRef.reData();
        });
      }
      this.searchMethods();
    },
    searchMethods() {
      this.loading = true;
      getOrderApply(this.formList)
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data.records;
            this.total = Number(res.data.total);
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.time_to_text {
  display: inline-block;
  font-size: 14px;
  margin: 0 5px;
  vertical-align: center;
  text-align: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
